import { defineStore } from 'pinia'

const useSettingStore = defineStore('settingStore', {
  state() {
    return {
      showOperationGuide: false,
      isJump: ''
    }
  },
  getters: {
  },
  actions: {
    setShowOperationGuide(showStatus: boolean) {
      this.showOperationGuide = showStatus
    },
    setIsJump(data: string) {
      this.isJump = data
    }
  }
})

export default useSettingStore